var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BlogPostList from '@marketing/components/navigation/BlogPostList';
import MoreInfo from '@marketing/components/navigation/MoreInfo';
import MenuItemList from '../../MenuItemList';
function LearnMore(_a) {
    var content = _a.content;
    var faqLibraryRoute = content.faqLibraryRoute, blogRoute = content.blogRoute, contactRoute = content.contactRoute, helpRoute = content.helpRoute;
    return (_jsxs("div", __assign({ className: "flex justify-start gap-2xl-gutter items-start h-full w-full" }, { children: [_jsxs("div", __assign({ className: "h-full flex flex-col justify-start items-start gap-5 shrink-0" }, { children: [_jsx(MenuItemList, { title: "Get Started", listStyles: "md:gap-y-[20px]", className: "md:gap-y-[20px]", menuItems: [
                            {
                                displayName: 'FAQ Library',
                                url: faqLibraryRoute,
                            },
                            {
                                displayName: 'Nom Nom Blog',
                                url: blogRoute,
                            },
                        ] }), _jsx(MoreInfo, { helpRoute: helpRoute, contactRoute: contactRoute })] })), _jsx(BlogPostList, {})] })));
}
export default LearnMore;
